import { Component, OnInit } from '@angular/core';
import { UserProfile } from '../../model/rolePlay.model';
import { HttpClient } from '@angular/common/http';
import { ChatService } from '../../service/chat-service';
import { ToastrService } from 'ngx-toastr';
import { AccessRequestDialogComponent } from '../access-request-dialog/access-request-dialog.component';
import { MatDialog } from '@angular/material/dialog';
const GRAPH_ENDPOINT = 'https://graph.microsoft.com/v1.0/me';
type ProfileType = {
  givenName?: string,
  surname?: string,
  userPrincipalName?: string,
  id?: string,
  displayName?: string,
  mail?: string
}
@Component({
    selector: 'app-unauthorizeduser',
    templateUrl: './unauthorizeduser.component.html',
    styleUrls: ['./unauthorizeduser.component.scss'],
    standalone: false
})

export class UnauthorizeduserComponent implements OnInit {

  userProfile!: UserProfile;
  profile!: ProfileType;
  filteredItems: any[] = ['TR', 'EP', 'JR-Velys'];
  filterValue: any;
  items: string[] = ['TR', 'EP', 'Velys'];
  products: any;
  constructor(private http: HttpClient, private chatService: ChatService, private readonly toastr: ToastrService, private dialog: MatDialog) { }
  email: string;
  loader = false;
  ngOnInit() {
    this.http.get(GRAPH_ENDPOINT)
      .subscribe(profile => {
        this.profile = profile;
        sessionStorage.setItem("profile", JSON.stringify(this.profile));
        sessionStorage.setItem("givenName", this.profile.givenName);
        sessionStorage.setItem("displayName", this.profile.displayName);
        sessionStorage.setItem("surname", this.profile.surname);
        //this.getGroups(this.profile);
      });
    this.productList();
  }
  productList() {
    this.chatService.getProductList().subscribe((res) => {
      this.products = Array.isArray(res) ? res.filter((p: any) => p && p.show_business_unit) : [];
    });
  }
  onAccessRequest(code: string) {
    let accessReq = {
      wwid: Number(sessionStorage.getItem('userId')),
      user_name: this.profile.givenName + ' ' + this.profile.surname,
      user_email: this.profile.mail,
      business_unit_code: code
    }

    this.chatService.accessRequest(accessReq, accessReq.wwid).subscribe(
      (response) => {
        // if(response.message){
        //   this.openDialog(response.message, "Info");
        // }else{
        this.openDialog(response.message, "Success");
        // }
      },
      (error) => {
        this.openDialog(error.message, "Error");
      }

    );
  }

  openDialog(message: string, type: string) {
    this.dialog.open(AccessRequestDialogComponent, {
      // width:'450px',
      data: { message: message, type: type }
    });
  }

}